import {DataRouterApplicationBuilder} from '@github-ui/react-core/future/data-router-application'

export const reposCommitActivityAppBuilder = DataRouterApplicationBuilder.create('repos-commit-activity')
